export default "<p>auth-validator works!</p>\r\n"